import {useState} from 'react'
import { Link, useNavigate} from "react-router-dom";
import { supabase } from './SupabaseClient'
import { useRecoilState } from 'recoil'
import { authSessionState } from '../atoms/auth'

import PrinterTokenModal from './PrinterTokenModal'
import {v4 as uuidv4} from 'uuid';

export default function AddPrinter() {
    const navigate = useNavigate();
    const [session, set_session] = useRecoilState(authSessionState)
    const [printer_name, set_printer_name] = useState("")
    const [modal_open, set_modal_open] = useState(false)
    const [token, set_token] = useState("")

    const handleNewPrinter = async () => {
        console.log("Add New Printer")

        const { data, error } = await supabase.functions.invoke('add_printer', {
          body: {user_id:session.user.id, printer_name: printer_name},
        })
        if (error){
            console.log(error)
            alert(error)
            return;
        }

        console.log(data)
        set_token(data.token_key)
        set_modal_open(true)
        //navigate("/printer")

    }
    
    return (
        <>
            <PrinterTokenModal
                modal_open={modal_open}
                set_modal_open={set_modal_open}
                printer_name={printer_name}
                token_data={token}
                move_url={"/printer"}
            ></PrinterTokenModal>

            <div className="bg-white py-6 sm:py-8 lg:py-12 w-full">
                <div className="px-4 md:px-8 mx-auto">
                    <div className="flex justify-between items-end gap-4 mb-6">
                        <h2 className="text-gray-800 text-2xl lg:text-3xl font-bold">新規プリンター追加</h2>
                    </div>

                    <div className="flex flex-col">
                        <div className="w-full mb-5">
                          <label  className="text-gray-800 text-sm sm:text-base mb-2">
                            プリンター名
                            <input 
                                type="text"
                                value={printer_name}
                                onChange={(e)=>{set_printer_name(e.target.value)}}
                                className="w-full bg-gray-50 text-gray-800 border focus:ring ring-indigo-300 rounded outline-none transition duration-100 px-3 py-2" />
                            </label>
                        </div>

                        <div className="w-full mt-5 mb-5">
                            <div className="flex flex-row-reverse">
                                <button onClick={handleNewPrinter} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded">
                                    プリンターの新規追加
                                </button>
                                <Link to="/" className="mr-5 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow">
                                    Canccel
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}